/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { FunctionComponent } from 'react';
import {
  Button,
  ButtonColor,
  ButtonSize,
  Logo,
  theme,
} from '@doveit/lego';
import { goToPage, URLObject } from '../../utils/links';
import { AdvFluidVariant } from '../../../domain/graphcms';
import * as styles from './AdvFluid.style';

export interface AdvFluidProps {
  title: string,
  description: string,
  symbolPath: string,
  cta: string,
  urlObject: URLObject,
  variant?: AdvFluidVariant,
  dataRef?: string,
  dataTracking?: string,
}

const AdvFluid: FunctionComponent<AdvFluidProps> = ({
  title,
  description,
  cta,
  symbolPath,
  urlObject,
  variant = AdvFluidVariant.VARIANT_1,
  dataRef,
  dataTracking,
}) => (
  <div
    css={styles.base}
    $variant={variant}
    data-ref={dataRef}
    data-tracking={dataTracking}
    onClick={() => goToPage(urlObject)}
  >
    <div css={styles.left}>
      <svg
        width="165"
        height="75"
        viewBox="0 0 165 75"
      >
        <g>
          <path
            fill={variant === AdvFluidVariant.VARIANT_1
              ? theme.palettes.neutrals.lightest
              : theme.palettes.brand.primary}
            d={symbolPath}
          />
        </g>
      </svg>
    </div>
    <div
      css={styles.center}
    >
      <div
        css={styles.title}
        $variant={variant}
      >
        {title}
      </div>
      <div
        css={styles.description}
        $variant={variant}
      >
        {description}
      </div>
    </div>
    <div
      css={styles.right}
    >
      <Button
        label={cta}
        title={cta}
        href={urlObject.as}
        onClick={(e) => e.preventDefault()}
        size={ButtonSize.SMALL}
        color={variant === AdvFluidVariant.VARIANT_1
          ? ButtonColor.PRIMARY
          : ButtonColor.SECONDARY}
        expanded
      />
    </div>
    <div
      css={styles.logo}
      $variant={variant}
    >
      <Logo />
    </div>
  </div>
);

export default AdvFluid;
